<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="max-width">
            <div class="form-group row mb-2">
                <div class="col-md-12 d-flex mb-4">
                    <button
                        class="action-btn action-btn-create"
                        role="button"
                        (click)="onOpenModalAddCoach()"
                        *ngIf="auth.permissions['SCHOOL_PROGRAM_COACH_ADD']">
                        <i-feather name="plus" class="feather-base"></i-feather>
                        {{ 'Add Coach' | translate }}
                    </button>
                </div>
                <!-- <div class="col-md-3">
                    <app-select-academic-year-only
                        (academicYearChanged)="onChangeAcademicYear($event)">
                    </app-select-academic-year-only>
                </div> -->
                <div class="col-md-3">
                    <app-select-school-level-relation-v2
                        (schoolLevelRelationChanged)="onChangeSchoolLevel($event)"
                        [academic_year]="null"
                        [with_academic_year]="false">
                    </app-select-school-level-relation-v2>
                </div>
                <!-- <div class="col-md-3">
                    <app-select-school-program
                        [academic_year]="this.paramForm.get('academic_year')?.value"
                        [school_location_id]="this.paramForm.get('school_location_id')?.value"
                        [isDisabled]="!this.paramForm.get('school_location_id')?.value"
                        (schoolProgramChanged)="onChangeSchoolProgram($event)">
                    </app-select-school-program>
                </div>
                <div class="col-md-3">
                    <app-select-school-program-category
                        [school_program_id]="this.paramForm.get('school_program_id')?.value"
                        [isDisabled]="!this.paramForm.get('school_program_id')?.value"
                        [all]="true"
                        (schoolProgramCategoryChanged)="onChangeSchoolProgramCategory($event)">
                    </app-select-school-program-category>
                </div> -->
            </div>
            <div class="table-responsive">
                <table mat-table
                    [dataSource]="dataCoach" multiTemplateDataRows
                    >
                    <ng-container matColumnDef="coach_name">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer">{{ 'Coach Name' | translate }}</th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.fullname}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="activity">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Activity' | translate }}</th>
                        <td mat-cell *matCellDef="let element" class="example-element-name">
                            {{element.activity.length}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="coach_fee">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Coach Fee' | translate }}</th>
                        <td mat-cell *matCellDef="let element" class="example-element-name">
                            {{ element.total_coach_fee | currency:'Rp' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action" *ngIf="auth.permissions['SCHOOL_PROGRAM_COACH_EDIT'] || auth.permissions['SCHOOL_PROGRAM_COACH_VIEW'] || auth.permissions['SCHOOL_PROGRAM_COACH_DELETE']">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center">{{ 'Actions' | translate }}</th>
                        <td mat-cell *matCellDef="let element" class="example-element-weight">
                            <div class="d-flex justify-content-center gap-1">
                                <button
                                    class="action-icon-btn action-icon-view"
                                    *ngIf="auth.permissions['SCHOOL_PROGRAM_COACH_EDIT'] || auth.permissions['SCHOOL_PROGRAM_COACH_VIEW']"
                                    (click)="onViewProfileCoach(element.user_id)"
                                    [title]="'DETAIL' | translate">
                                    <div>
                                        <i-feather name="eye" class="feather-base"></i-feather>
                                    </div>
                                </button>
                                <button
                                    class="action-icon-btn action-icon-delete"
                                    *ngIf="auth.permissions['SCHOOL_PROGRAM_COACH_DELETE']"
                                    (click)="onDeleteCoach(element.user_id)"
                                    [title]="'DELETE' | translate">
                                    <div>
                                        <i-feather name="trash-2" class="feather-base"></i-feather>
                                    </div>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;" class="example-element-row">
                    </tr>
                </table>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<ng-template #addCoach let-modal let-close="close">
    <div [formGroup]="modalForm" class="row modal-add">
        <!-- <div class="col-md-3">
            <app-select-academic-year-only
                (academicYearChanged)="onChangeAcademicYearModal($event)">
            </app-select-academic-year-only>
        </div> -->
        <div class="col-md-4 mb-4">
            <app-select-school-level-relation-v2
                [academic_year]="null"
                (schoolLevelRelationChanged)="onChangeSchoolLevelModal($event)"
                [with_academic_year]="false">
            </app-select-school-level-relation-v2>
        </div>
        <mat-tab-group>
            <mat-tab label="{{ 'Coach' | translate }}">
                <div>
                    <div class="d-grid mt-3 mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Coach Photo Profile' | translate }}</span>
                        <img style="width: 100px; height: 100px" id="" [src]="imageSrc" alt="profile image" />
                        <input type="file" (change)="readURL($event)">
                    </div>
                    <div class="d-grid mt-3 mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Coach Username' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                        <input placeholder="{{ 'Coach Name' | translate }}"
                                (change)="trackAddCoachChanges()"
                                class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                                style="outline: none;" formControlName="username">
                    </div>
                    <div class="d-grid mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Coach Name' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                        <input placeholder="{{ 'Coach Name' | translate }}"
                                (change)="trackAddCoachChanges()"
                                class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                                style="outline: none;" formControlName="fullname">
                    </div>
                    <div class="d-grid mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Coach Email' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                        <input placeholder="{{ 'Coach Email' | translate }}"
                                type="email"
                                email
                                (change)="trackAddCoachChanges()"
                                class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                                style="outline: none;" formControlName="email">
                        <div *ngIf="!this.modalForm.get('email')?.valid" style="font-size: 14px; color: red;" class="mb-2">{{ 'Email not valid' | translate }}</div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="{{ 'Personal Data' | translate }}">
                <div>
                    <div class="d-grid mt-3 mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Date of Birth' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                        <input type="date" (change)="trackAddCoachChanges()" class="form-control" placeholder="{{ 'Start date' | translate }}" formControlName="date_of_birth">
                    </div>
                    <div class="d-grid mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Place of Birth' | translate }}</span>
                        <input placeholder="{{ 'Input place of birth' | translate }}"
                                type="text"
                                class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                                style="outline: none;" formControlName="place_of_birth">
                    </div>
                    <div class="d-grid mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Gender' | translate }}</span>
                        <ng-select
                                formControlName = "gender"
                                [placeholder]="modalForm.get('gender')?.value ? '' : 'Select gender'"
                                [items]="genderList"
                                class="selector-style">
                            <ng-template ng-option-tmp let-item="item">
                                <div class="custom-option-style" title="{{item}}">{{item}}</div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="d-grid mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Marital Status' | translate }}</span>
                        <ng-select
                                formControlName = "marital_status"
                                [placeholder]="modalForm.get('marital_status')?.value ? '' : 'Select status'"
                                [items]="maritalStatusList"
                                class="selector-style">
                            <ng-template ng-option-tmp let-item="item">
                                <div class="custom-option-style" title="{{item}}">{{item}}</div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="d-grid mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Religion' | translate }}</span>
                        <ng-select
                                formControlName = "religion_id"
                                [placeholder]="modalForm.get('religion_id')?.value ? '' : 'Select religion'"
                                [items]="religionList"
                                bindLabel="religion_name"
                                bindValue="religion_id"
                                class="selector-style">
                            <ng-template ng-option-tmp let-item="item">
                                <div class="custom-option-style" title="{{item.religion_name}}">{{item.religion_name}}</div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="d-grid mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Nationality' | translate }}</span>
                        <ng-select
                                formControlName = "nationality_id"
                                [placeholder]="modalForm.get('nationality_id')?.value ? '' : 'Select nationality'"
                                [items]="nationalityList"
                                bindLabel="nationality_name"
                                bindValue="nationality_id"
                                class="selector-style">
                            <ng-template ng-option-tmp let-item="item">
                                <div class="custom-option-style" title="{{item.nationality_name}}">{{item.nationality_name}}</div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="d-grid mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Nationality Type ID' | translate }}</span>
                        <ng-select 
                                formControlName = "nationality_id_type"
                                [placeholder]="modalForm.get('nationality_id_type')?.value ? '' : 'Select nationality type'"
                                [items]="nationalityTypeList"
                                class="selector-style">
                            <ng-template ng-option-tmp let-item="item">
                                <div class="custom-option-style" title="{{item}}">{{item}}</div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="d-grid mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Nationality Type Number' | translate }}</span>
                        <input placeholder="{{ 'Input nationality type number' | translate }}"
                                type="text"
                                class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                                style="outline: none;" formControlName="nationality_id_number">
                    </div>
                    <div class="d-grid mb-3">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'NPWP' | translate }}</span>
                        <input placeholder="{{ 'Input NPWP' | translate }}"
                                type="text"
                                class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                                style="outline: none;" formControlName="npwp">
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="{{ 'Contact Information' | translate }}">
                <div class="d-grid mt-3 mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Phone Number' | translate }}</span>
                    <input placeholder="{{ 'Input phone number' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="phone_number">
                </div>
                <div class="d-grid mt-3 mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Cellular Number' | translate }}</span>
                    <input placeholder="{{ 'Input phone number' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="cellular_number">
                </div>
                <div class="d-grid mt-3 mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Alternative Email Address' | translate }}</span>
                    <input placeholder="{{ 'Input phone number' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="alternative_email_address">
                </div>
            </mat-tab>
            <mat-tab label="{{ 'Address Information' | translate }}">
                <div class="d-grid mt-3 mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Country' | translate }}</span>
                    <ng-select
                            [placeholder]="modalForm.get('country_id')?.value ? '' : 'Select country'"
                            formControlName = "country_id"
                            (change)="getProvince()"
                            [items]="countryList"
                            bindLabel="country_name"
                            bindValue="country_id"
                            class="selector-style">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style" title="{{item.country_name}}">{{item.country_name}}</div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="d-grid mt-3 mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Province' | translate }}</span>
                    <ng-select
                            [placeholder]="modalForm.get('province_id')?.value ? '' : 'Select province'"
                            formControlName = "province_id"
                            [items]="province"
                            bindLabel="province_name"
                            bindValue="province_id"
                            class="selector-style">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style" title="{{item.province_name}}">{{item.province_name}}</div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'City' | translate }}</span>
                    <input placeholder="{{ 'Input city' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="city">
                </div>
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Full Address' | translate }}</span>
                    <textarea placeholder="{{ 'Input full address' | translate }}"
                              class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                              style="outline: none; resize: none;" 
                              rows="4"
                              formControlName="full_address"></textarea>
                </div>                
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Postal Code' | translate }}</span>
                    <input placeholder="{{ 'Input postal code' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="postal_code">
                </div>
            </mat-tab>
            <mat-tab label="{{ 'Finance Information' | translate }}">
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Coach Fee/Day' | translate }}</span>
                    <input placeholder="{{ 'Input coach fee' | translate }}"
                            type="text"
                            mask="separator.0" thousandSeparator="."
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="coach_fee">
                </div>
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Bank Account' | translate }}</span>
                    <input placeholder="{{ 'Input bank account name' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="bank_account">
                </div>
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Bank Account Number' | translate }}</span>
                    <input placeholder="{{ 'Input bank account number' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="account_number">
                </div>
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Account Holder Name' | translate }}</span>
                    <input placeholder="{{ 'Input bank account holder name' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="account_holder_name">
                </div>
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Bank Office Branch' | translate }}</span>
                    <input placeholder="{{ 'Input bank office branch' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="bank_office_brand">
                </div>
            </mat-tab>
            <mat-tab label="{{ 'Institute Information' | translate }}">
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Institute Name' | translate }}</span>
                    <input placeholder="{{ 'Input institute name' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="institute_name">
                </div>
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Institute Office Number' | translate }}</span>
                    <input placeholder="{{ 'Input institute office number' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="institute_office_number">
                </div>
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Institute Email Address' | translate }}</span>
                    <input placeholder="{{ 'Input institute email address' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="institute_email_address">
                </div>
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Institute Address' | translate }}</span>
                    <textarea placeholder="{{ 'Input institute address' | translate }}"
                            type="text"
                            rows="4"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none; resize: none;" formControlName="institute_address"></textarea>
                </div>
                <div class="d-grid mb-3">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Coach Remarks' | translate }}</span>
                    <input placeholder="{{ 'Input coach remarks' | translate }}"
                            type="text"
                            class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                            style="outline: none;" formControlName="coach_remarks">
                </div>
            </mat-tab>
        </mat-tab-group>
        <div class="col-md-12 d-flex mb-2 mt-4">
            <button class="gradient-button col-md-2 me-1" role="button" [disabled]="disabledAddCoach" (click)="onSaveCoach()" *ngIf="auth.permissions['SCHOOL_PROGRAM_COACH_ADD']">{{ 'Save' | translate }}</button>
        </div>
        <!-- <div class="col-md-12 d-flex mb-2 mt-4">
            <button class="gradient-button col-md-2 me-1" role="button" (click)="test()">TEST</button>
        </div> -->
    </div>
</ng-template>
